import { useQuery } from '@apollo/client'

import { gql } from '@/clients/utoniq-core'
import {
  GachaItemListQuery,
  GachaItemListQueryVariables,
  GachaItemsConnectionFragmentDoc,
} from '@/clients/utoniq-core/schema'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { router } = useRouter<{ gachaId: string }>()
  const { data, loading } = useQuery<
    GachaItemListQuery,
    GachaItemListQueryVariables
  >(QUERY, { variables: { gachaId: router.query.gachaId } })

  return {
    state: {
      loading,
      rollAlgorithm: data?.gacha?.rollAlgorithm ?? null,
      items: data?.gacha?.items ?? null,
    },
    actions: {},
  }
})

const QUERY = gql`
  query GachaItemList($gachaId: ID!) {
    gacha(id: $gachaId) {
      id
      rollAlgorithm
      items {
        ...GachaItemsConnection
      }
    }
  }
  ${GachaItemsConnectionFragmentDoc}
`
